import React, { Component, useContext, useEffect, useState } from 'react';
import { Route, withRouter } from 'react-router';
import { BrandingContext, BrandingProvider } from './components/contexts/ContractContext';
import { SalesProvider } from './components/contexts/SalesContext';
import '../src/css/autodropdown.css';
import { Helmet } from 'react-helmet';
import NJRFavicon from './assets/images/Vendor/NJR/favicon.ico';
import AIGFavicon from './assets/images/aigfavicon.ico';
import { ProgramSummary } from './screens/Vendor/Apple/ProgramSummary';
import CoverageDocs from './screens/Vendor/Apple/CoverageDocs';
import { Redirect, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { WhiteLabelController } from './components/_BrandingProvider/WhiteLabelProvider';
import { HeaderController } from './components/Headers/HeaderController';
import { FooterController } from './components/Footers/FooterController';
import qs from 'qs';
import { verifyHwaToken, getHwaRedirectUrl, isAppleRoute } from '../src/helpers';
import FAQ from './components/FAQ/FAQ';
import ResumeContract from './components/Sales/ResumeContract';
import CustomerInfo from './components/Sales/CustomerInfo';
import SalesConfirmation from './components/Sales/SalesConfirmation';
import ShopPlan from './components/ShopPlan/ShopPlan';
import { LanguageProvider } from './components/contexts/LanguageTranslation/LanguageContext';
import ReviewPlanDetails from './components/Sales/ReviewPlanDetails';
import NJRContactUs from './screens/Vendor/NJR/ContactUs/NJRContactUs';
import NJRLanding from './components/NJRLanding/NJRLanding';
import NJRDecommission from './components/NJRLanding/NJRDecommission';
import { NJRPayment } from './components/Sales/PaymentInformation/Payment';
import OrderSummary from './components/Sales/OrderSummary';
import DevelopmentBrandToggler from './components/_BrandingProvider/DevelopmentBrandToggler';
import ShopDTC from './screens/DTC';
import { BuildPlanContextProvider } from './components/contexts/DTC/DTCContext';
import DTCHome from './components/DTC/DTCHome';
import PlanBenefits from './components/Vendor/NJR/PlanOptions/PlanBenefits';
import ContactConfirmation from './components/Vendor/NJR/ContactConfirmation/Contactconfirmation';
import SalesReviewPage from './components/Sales/SalesReviewPage';
import Home from './components/shared/Home';
import DeviceDetails from './components/Sales/DeviceDetails';
import { MaintenancePage } from './screens/MaintenancePage';

export default function App() {
    const [isDevelopmentEnvironment, setIsDevelopmentEnvironment] = useState(false);
    //const njrMatch = useRouteMatch('njr.serviceplans.com');
    const [isDecommission, setIsDecommission] = useState(false);
    const [clientId, setClientId] = useState('aig');

    const lowerEnvs = ['local', 'development', 'staging'];

    // FIND ENVIRONMENT AND SET TO ALLOW ENV-SPECIFIC COMPOENENTS TO RENDER
    useEffect(() => {
        const getenvironment = async () => {
            await fetch('api/helper/getenvironment', {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then((res) => res.json())
                .then((envRes) => {
                    const envLower = envRes.environment.toLowerCase();
                    if (lowerEnvs.includes(envLower)) {
                        setIsDevelopmentEnvironment(true);
                    }
                });
        };
        const getClientByUrl = async () => {
            await fetch('api/helper/getclientbyurl', {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then((res) => res.json())
                .then((envRes) => {
                    const client = envRes.clientId.toLowerCase();
                    if (client === 'njr') {
                        setIsDecommission(true);
                    }
                    setClientId(client);
                });
        };
        getenvironment();
        getClientByUrl();

        checkIsUserAgent();

        return () => {};
    }, []);

    //useEffect(() => {
    //    if (njrMatch) {
    //        setIsdecommission(true)
    //        return;
    //    }
    //    setIsdecommission(false)
    //}, [])

    // const checkAndVerifyHwaToken = async () => {
    //     const token = qs.parse(window.location.search, { ignoreQueryPrefix: true }).id;
    //     if (typeof token !== "undefined" && token !== "" && token !== null) {
    //         // hwa, verify the token and redirect if invalid
    //         const isTokenValid = await verifyHwaToken(token);
    //         // console.log(isTokenValid);
    //         if (!isTokenValid) {
    //             const url = await getHwaRedirectUrl();
    //             window.location.href = `${url}/auth/login`;
    //         }
    //     }
    // }
    const checkIsUserAgent = async () => {
        const { agent } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        const sessionAgent = sessionStorage.getItem('isAgentEntry');

        console.log(agent, sessionAgent);

        if (
            (typeof agent !== 'undefined' && agent !== '' && agent !== null)
            || (typeof sessionAgent !== 'undefined'
                && sessionAgent !== ''
                && sessionAgent !== null
                && sessionAgent !== ''
                && sessionAgent !== false)
        ) {
            sessionStorage.setItem('isAgentEntry', true);
        }
    };

    const handleSkip = (e) => {
        e.preventDefault();
        document.getElementById('reach-skip-nav').scrollIntoView({
            behavior: 'smooth'
        });
        document.getElementById('reach-skip-nav').focus();
    };

    return (
        <BrandingProvider>
            <WhiteLabelController>
                <BuildPlanContextProvider>
                    <LanguageProvider>
                        <SalesProvider>
                            <ResumeContract>
                                <HelmetComponent /> {/* HANDLES PAGE TITLE, FAVICON, METADATA */}
                                <div
                                    className='skip_nav'
                                    role='navigation'
                                    aria-label='skip navigation'
                                >
                                    <a href='#shopBtnHero'>Skip to Content</a>
                                </div>
                                <HeaderController role='header' />
                                <main
                                    role='main'
                                    style={{ minHeight: 'calc(100vh - 235px)', position: 'relative' }}
                                >
                                    <Switch>
                                        {/* STATIC SALES AND LANDING PAGES */}
                                        {/*Decommission NJR Sales Portal*/}

                                        {isDecommission && !isDevelopmentEnvironment ? (
                                            <Route
                                                exact
                                                path='/'
                                                component={NJRDecommission}
                                            />
                                        ) : (
                                            <Route
                                                exact
                                                path='/'
                                                component={Home}
                                            />
                                        )}

                                        <Route
                                            exact
                                            path='/maintenance'
                                            component={MaintenancePage}
                                        />
                                        <Route
                                            path='/shopplan'
                                            component={ShopPlan}
                                        />
                                        <Redirect
                                            from='/shopplan'
                                            to='/'
                                        />
                                        {/* SALES FLOW */}
                                        <Route
                                            exact
                                            path='/customerinfo'
                                            component={CustomerInfo}
                                        />
                                        <Redirect
                                            from='/customerinfo'
                                            to='/'
                                        />
                                        <Route
                                            exact
                                            path='/ReviewPlanDetails'
                                            component={ReviewPlanDetails}
                                        />
                                        <Redirect
                                            from='/ReviewPlanDetails'
                                            to='/'
                                        />
                                        <Route
                                            exact
                                            path='/sales/payment'
                                            component={NJRPayment}
                                        />
                                        <Redirect
                                            from='/sales/payment'
                                            to='/'
                                        />
                                        <Route
                                            exact
                                            path='/confirmation/:confirmationId'
                                            component={SalesConfirmation}
                                        />
                                        <Redirect
                                            from='/confirmation/:confirmationId'
                                            to='/'
                                        />
                                        <Route
                                            exact
                                            path='/buy/protectionplan'
                                            component={DeviceDetails}
                                        />
                                        <Route
                                            exact
                                            path='/buy/reviewplan'
                                            component={SalesReviewPage}
                                        />
                                        <Redirect
                                            from='/buy/reviewplan'
                                            to='/'
                                        />
                                        {/* CUSTOMER SERVICE PAGES  */}
                                        <Route
                                            exact
                                            path='/contactus'
                                            component={NJRContactUs}
                                        />
                                        <Route
                                            exact
                                            path='/faq'
                                            component={FAQ}
                                        />

                                        <Redirect
                                            from='/faq'
                                            to='/'
                                        />

                                        {/* DEVELOPMENT PATHS - FOR DEV ONLY, WILL NOT REMAIN AS OWN "ROUTES" WHEN DEVELOPMENT IS COMPLETE */}
                                        <Route
                                            exact
                                            path={'/dtc'}
                                            component={DTCHome}
                                        />
                                        <Route
                                            exact
                                            path={'/dtc/shop'}
                                            component={ShopDTC}
                                        />
                                    </Switch>
                                </main>
                                <FooterController isDevEnv={isDevelopmentEnvironment} />
                                {isDevelopmentEnvironment && <DevelopmentBrandToggler />}
                            </ResumeContract>
                        </SalesProvider>
                    </LanguageProvider>
                </BuildPlanContextProvider>
            </WhiteLabelController>
        </BrandingProvider>
    );
}

// ALLOWS HELMET TO ACCESS ContractContext
const HelmetComponent = () => {
    const context = useContext(BrandingContext);
    const { clientId } = context;

    if (!clientId)
        return (
            <Helmet>
                <link
                    rel='icon'
                    href=''
                />
                <title></title>
            </Helmet>
        );

    const meta = getMetaDataByClient(clientId);
    return (
        <Helmet>
            <meta charSet='utf-8' />
            {/* <meta name="description" content="this is react-helmet tutorial" /> */}
            <meta
                name='viewport'
                content='width=device-width, initial-scale=1.0'
            />
            <link
                rel='icon'
                href={meta.favicon}
            />
            <title>{meta.title}</title>
        </Helmet>
    );
};

// Can take a client ID and a page and return a full title, IE "AIG Sales | Plan Overview"
export const getMetaDataByClient = (clientId, append) => {
    const concatenated = (titleString) => {
        if (!append) return titleString;
        return titleString.concat(' | ', append);
    };

    const defaultMetaData = {
        favicon: null,
        title: concatenated('AIG Sales Portal')
    };

    if (isAppleRoute())
        return {
            favicon: AIGFavicon,
            title: ''
        };

    switch (clientId) {
        case 'NJR':
            return {
                favicon: NJRFavicon,
                title: concatenated('NJR Retail Service Plans')
            };
        default:
            return defaultMetaData;
    }
};
